export interface AwsCognitoOAuthOpts {
    domain: string,
    scope: Array<string>,
    redirectSignIn: string,
    redirectSignOut: string,
    responseType: string,
    options?: object,
    urlOpener?: (url: string, redirectUrl: string) => Promise<any>
}